"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerModule = void 0;

var CONFIG = _interopRequireWildcard(require("./config"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LoggerModule = /*#__PURE__*/function () {
  function LoggerModule() {
    var _this = this;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LoggerModule);

    _defineProperty(this, "options", void 0);

    _defineProperty(this, "hook", void 0);

    _defineProperty(this, "themes", void 0);

    this.options = props.options;
    this.hook = props.hook;
    this.themes = {
      info: {
        color: CONFIG.FGBLACK,
        colorHex: "#ccc",
        bg: CONFIG.BGWHITE,
        bgHex: "#999"
      },
      warning: {
        color: CONFIG.FGBLACK,
        colorHex: "#000",
        bg: CONFIG.BGYELLOW,
        bgHex: "#ff0"
      },
      error: {
        color: CONFIG.FGWHITE,
        colorHex: "#fff",
        bg: CONFIG.BGRED,
        bgHex: "#f00"
      },
      success: {
        color: CONFIG.FGBLACK,
        colorHex: "#fff",
        bg: CONFIG.BGGREEN,
        bgHex: "#108400"
      },
      black: {
        color: CONFIG.FGWHITE,
        colorHex: "#fff",
        bg: CONFIG.BGBLACK,
        bgHex: "#000"
      },
      blue: {
        color: CONFIG.FGWHITE,
        colorHex: "#fff",
        bg: CONFIG.BGBLUE,
        bgHex: "#00f"
      },
      cyan: {
        color: CONFIG.FGWHITE,
        colorHex: "#fff",
        bg: CONFIG.BGCYAN,
        bgHex: "#0ff"
      },
      magenta: {
        color: CONFIG.FGWHITE,
        colorHex: "#fff",
        bg: CONFIG.BGMAGENTA,
        bgHex: "#f0f"
      }
    };
    Object.keys(this.themes).forEach(function (theme) {
      //@ts-ignore
      _this[theme] = function (key) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        _this.log.apply(_this, [key, _this.themes[theme]].concat(rest));
      }; //@ts-ignore


      _this[theme] = _this[theme].bind(_this);
    }); //@ts-ignore

    this.browser = {};
    Object.keys(this.themes).forEach(function (theme) {
      //@ts-ignore
      _this.browser[theme] = function (key) {
        for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          rest[_key2 - 1] = arguments[_key2];
        }

        _this.log.apply(_this, [key, _objectSpread(_objectSpread({}, _this.themes[theme]), {}, {
          onlyBrowser: true
        })].concat(rest));
      };
    });
  }

  _createClass(LoggerModule, [{
    key: "log",
    value: //@ts-ignore
    function log(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$options = this.options,
          browser = _this$options.browser,
          visible = _this$options.visible,
          _this$options$coloriz = _this$options.colorize,
          colorize = _this$options$coloriz === void 0 ? true : _this$options$coloriz; //@ts-ignore

      var color = options.color,
          colorHex = options.colorHex,
          bg = options.bg,
          bgHex = options.bgHex,
          onlyBrowser = options.onlyBrowser;

      for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      if (visible) {
        if (!colorize) {
          var _console;

          (_console = console).log.apply(_console, ["[".concat(key, "]")].concat(rest));
        } else {
          if (browser) {
            var _console2;

            (_console2 = console).log.apply(_console2, ["%c ".concat(key, " "), "background: ".concat(bgHex, "; color: ").concat(colorHex)].concat(rest));
          } else {
            if (!onlyBrowser) {
              var _console3;

              if (!this.options.dontUseSeparator) {
                console.log(" ");
              }

              (_console3 = console).log.apply(_console3, ["".concat(bg + color), key, CONFIG.RESET].concat(rest));
            }
          }
        }
      }

      if (this.hook) {
        this.hook.apply(this, [key].concat(rest));
      }
    } //@ts-ignore

  }, {
    key: "group",
    value: function group() {
      if (this.options.visible) {
        var _console4;

        (_console4 = console).groupCollapsed.apply(_console4, arguments);
      }
    }
  }, {
    key: "groupEnd",
    value: function groupEnd() {
      if (this.options.visible) {
        console.groupEnd();
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!LoggerModule.instance) {
        LoggerModule.instance = new LoggerModule(props);
      }

      return LoggerModule.instance;
    }
  }]);

  return LoggerModule;
}();

exports.LoggerModule = LoggerModule;

_defineProperty(LoggerModule, "instance", void 0);